import axios from "axios";
import store from "@/store";
import { Toast } from "vant";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_PRE, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 12*10 * 1000, // request timeout
});

// request拦截器 request interceptor
service.interceptors.request.use(
  (config) => {
    // 不传递默认开启loading
    if (!config.hideloading) {
      // loading
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
    }
    if (store.state.token.token) {
      config.headers["Authorization"] = `Bearer ` + store.state.token.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// respone拦截器
service.interceptors.response.use(
  (res) => {
    Toast.clear();
    switch (res.data.code) {
      case 200:
        return res.data;
      case 401:
        Toast.fail('未授权，请重新登录');
        // 可以在这里进行登出操作
        break;
      case 403:
        Toast.fail('权限不足，请联系管理员');
        break;
      case 404:
        Toast.fail('请求的资源不存在');
        break;
      default:
        Toast.fail(res.data.msg);
    }
  },
  (error) => {
    Toast.clear();
    console.log("err" + error);
    return Promise.reject(error);
  }
);

export default service;
